module.exports = __webpack_public_path__ + "img/bg.6d8356ab.png";